<template>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Recibo de Nómina</h4>
                <button ref="closePayrollModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-4">
                        <div class="card" style="border: 1px solid #CCC;">
                            <div class="card-header card-no-border" style="padding: 15px;">
                                <h5 style="font-size: 16px;">Emisor</h5><br />
                                <span style="font-size: 12px; font-weight: bold;">{{ employee ? employee.employer_rfc : '' }}</span>
                                <span style="font-size: 12px;">{{ employee ? employee.employer_name : '' }}</span>
                            </div>
                            <div class="card-body pt-0"></div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card" style="border: 1px solid #CCC;">
                            <div class="card-header card-no-border" style="padding: 15px;">
                                <h5 style="font-size: 16px;">Receptor</h5><br />
                                <span style="font-size: 12px; font-weight: bold;">{{ employee ? employee.rfc : '' }}</span>
                                <span style="font-size: 12px;">{{ employee ? employee.name : '' }}</span>
                            </div>
                            <div class="card-body pt-0"></div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card" style="border: 1px solid #CCC;">
                            <div class="card-header card-no-border" style="padding: 15px;">
                                <h5 style="font-size: 16px;">Información</h5><br />
                                <span style="font-size: 12px; font-weight: bold;">Periodo: {{ employee ? $formatDate(employee.initial) : '' }} al {{ employee ? $formatDate(employee.final) : '' }}</span>
                                <span style="font-size: 12px;">Días Trabajados: {{ employee ? employee.work_days : '' }}</span>
                            </div>
                            <div class="card-body pt-0"></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="card" style="border: 1px solid #CCC;">
                            <div class="card-header card-no-border" style="padding: 15px;">
                                <h5 style="font-size: 16px;">Percepciones</h5>
                                <br />
                                <span style="float: right; text-align: right;">
                                    {{ employee ? $formatCurrency(employee.salary) : '' }}<br />
                                    <span v-if="employee && employee.vacation_bonus > 0">{{ employee ? $formatCurrency(employee.vacation_bonus) : '' }}</span><br />
                                    <br />
                                    <br />
                                    <br />
                                    <b>{{ employee ? $formatCurrency(employee.salary*1 + employee.vacation_bonus*1) : '' }}</b>
                                </span>
                                <span style="padding-left: 10px;">
                                    Sueldos y Salarios<br />
                                    <span v-if="employee && employee.vacation_bonus > 0">Prima Vacacional</span><br />
                                    <br />
                                    <br />
                                    <br />
                                    <b>Total de las Percepciones</b>
                                </span>
                            </div>
                            <div class="card-body pt-0"></div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card" style="border: 1px solid #CCC;">
                            <div class="card-header card-no-border" style="padding: 15px;">
                                <h5 style="font-size: 16px;">Deducciones</h5>
                                <br />
                                <span style="float: right; text-align: right;">
                                    {{ employee ? $formatCurrency(employee.isr) : '' }}<br />
                                    {{ employee ? $formatCurrency(employee.imss) : '' }}<br />
                                    <span v-if="employee && employee.infonavit > 0">{{ employee ? $formatCurrency(employee.infonavit) : '' }}</span><br />
                                    <span v-if="employee && employee.fonacot > 0">{{ employee ? $formatCurrency(employee.fonacot) : '' }}</span><br />
                                    <br />
                                    <b>{{ employee ? $formatCurrency(employee.isr*1 + employee.imss*1 + employee.infonavit*1 + employee.fonacot*1) : '' }}</b>
                                </span>
                                <span style="padding-left: 10px;">
                                    ISR<br />
                                    IMSS<br />
                                    <span v-if="employee && employee.infonavit > 0">Infonavit</span><br />
                                    <span v-if="employee && employee.fonacot > 0">Fonacot</span><br />
                                    <br />
                                    <b>Total de las Deducciones</b>
                                </span>
                            </div>
                            <div class="card-body pt-0"></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" style="font-size: 16px; font-weight: bold;">
                        <span style="float: right;text-align: right;">
                            Fiscal: {{ employee ? $formatCurrency(employee.salary*1 + employee.vacation_bonus*1 - employee.isr*1 - employee.imss*1 - employee.infonavit*1 - employee.fonacot*1) : '' }}
                            <br />
                            Complementario: {{ $formatCurrency(employee ? employee.net_complementary : '') }}
                            <br />
                            -------------------------------
                            <br />
                            Total: {{ $formatCurrency(employee ? employee.salary*1 + employee.vacation_bonus*1 - employee.isr*1 - employee.imss*1 - employee.infonavit*1 - employee.fonacot*1 + employee.net_complementary*1 : '') }}
                        </span>
                        Total a Pagar: 
                    </div>
                </div>
            </div>
            <div class="modal-footer" style="justify-content: space-between;">
                <span><button v-if="payroll != null && payroll != false" class="btn btn-dark btn-sm" type="button" style="float: left;"title="btn btn-success btn-sm" @click="cancelPayroll">Cancelar</button></span>
                <span style="display: flex; justify-content: flex-end;">
                    <button v-if="payroll == null || payroll == false" class="btn btn-primary btn-sm" type="button" style="float: right; margin-left: 10px;" title="btn btn-success btn-sm" @click="storePayroll">Timbrar Nómina</button>
                    <a v-if="payroll != null && payroll != false" class="btn btn-success btn-sm" type="button" style="float: right; margin-left: 10px;" title="btn btn-success btn-sm" target="_blank" :href="payroll.xml_url">XML</a>
                    <a v-if="payroll != null && payroll != false" class="btn btn-danger btn-sm" type="button" style="float: right; margin-left: 10px;" title="btn btn-success btn-sm" target="_blank" :href="payroll.pdf_url">PDF</a>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'

export default {
    name: 'employee_payroll_modal',
    mixins: [],
    props: {
        employees: Array,
    },
    components: {
        
    },
    data(){
        return{
            showModal: true,
            employee: null,
            period: null,
            type: 'O', //Nómina Ordinaria,
            payroll: null
        }
    },
    beforeMount: async function() {

    },
    methods: {
        loadEmployee(employee, period){
            this.employee = employee;
            this.period = period;
            this.payroll = employee.payroll;
        },
        async storePayroll() {
            this.employee.sub_total = this.employee.salary*1 + this.employee.vacation_bonus*1;
            this.employee.descuentos = this.employee.isr*1 + this.employee.imss*1 + this.employee.infonavit*1 + this.employee.fonacot*1;
            this.employee.total = this.employee.sub_total - this.employee.descuentos;

            let response = await ws.storePayroll(this.employee, this.period, this.type);

            if(response.type == "success"){
                this.$toast.success(response.message);
                this.$emit("refresh", response.data );

                this.payroll = response.data;

                //No cerrar el modal, ya que se va a mostrar el XML y PDF
                //this.closeModal();
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closePayrollModal.click();
        }
    }
}
</script>